import React, { useState, useEffect } from "react";
import { Grid, Text, Spinner, Alert, AlertIcon } from "@chakra-ui/react";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Component_bus = () => {
  const [busData, setBusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const studentId = sessionStorage.getItem("student_id"); // Example student ID
    const schoolId = sessionStorage.getItem("school_id"); // Example school ID

    const fetchBusData = async () => {
      try {
        console.log("Fetching bus data...");

        const response = await fetch(
          `${BASE_URL}/student/bus/bus_details.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              student_id: studentId,
              school_id: schoolId,
            }),
          }
        );

        if (!response.ok) {
          console.error("Failed to fetch: ", response.status);
          setError(null); // Avoid setting an error if there's no bus data
          return;
        }

        const data = await response.json();
        if (data.success) {
          setBusData(data.data);
        } else {
          setBusData(null); // If no bus data, set busData to null
        }
      } catch (error) {
        console.error("Error occurred:", error);
        setError(null); // Avoid showing "Failed to fetch" error
      } finally {
        setLoading(false);
      }
    };

    fetchBusData();
  }, []);

  if (loading) {
    return <Spinner size="xl" />;
  }

  // if (error) {
  //   return (
  //     <Alert status="error">
  //       <AlertIcon />
  //       {error}
  //     </Alert>
  //   );
  // }

  if (!busData) {
    return (
      <Text fontSize="lg" fontWeight="bold" textAlign="center">
        No Bus Found
      </Text>
    );
  }

  return (
    <div>
      <Grid
        templateColumns="repeat(2, 1fr)"
        gap={6}
        alignItems="baseline"
        ml={6}
      >
        <Text fontWeight="bold" fontSize="xl" gridColumn="span 2">
          Bus Information
        </Text>
        {busData.start_place && (
          <Text fontSize="lg">Departure: {busData.start_place}</Text>
        )}
        {busData.end_place && (
          <Text fontSize="lg">Destination: {busData.end_place}</Text>
        )}

        {busData.trip === "One way" && busData.pickup_location_name && (
          <Text fontSize="lg">
            Pickup Point: {busData.pickup_location_name}
          </Text>
        )}
        {busData.trip === "One way" && busData.drop_location_name && (
          <Text fontSize="lg">Drop Point: {busData.drop_location_name}</Text>
        )}
        {busData.trip !== "One way" && (
          <>
            <Text fontSize="lg">
              Pickup Point: {busData.pickup_location_name}
            </Text>
            <Text fontSize="lg">Drop Point: {busData.drop_location_name}</Text>
          </>
        )}
          {busData.bus_fee && (
          <Text fontSize="lg">Bus Fees: {busData.bus_fee}</Text>
        )}
      </Grid>
    </div>
  );
};

export default Component_bus;